export const extractPhoneDigits = (phone?: string): string => {
  if (!phone) return ''
  return phone.replace(/\D/g, '')
}

export const formatPhoneNumber = (phone?: string): string => {
  if (!phone) return ''

  const digitsOnly = extractPhoneDigits(phone)

  if (digitsOnly.length === 10) {
    return `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6)}`
  }

  return phone
}

export const arePhoneNumbersEqual = (
  phone1?: string,
  phone2?: string,
): boolean => {
  return extractPhoneDigits(phone1) === extractPhoneDigits(phone2)
}
